export { default as Team } from './Team';
export { default as Features } from './Features';
export { default as Hero } from './Hero';
export { default as Partners } from './Partners';
export { default as Process } from './Process';
export { default as Reviews } from './Reviews';
export { default as Work } from './Work';
